module.exports = __webpack_public_path__ + "img/chat-gpt-integration.2ec49448.webp";